import React from "react";
import { useTable } from "react-table";
import { motion } from "framer-motion";
import { BiServer } from "react-icons/bi";
import { Table, Thead, Tr, Th, Tbody, Td, Center, Tfoot, Text } from "@chakra-ui/react";
import { Spinner } from "../../Loader";
const MotionRow = motion(Tr);

export default function PayslipTable({ background = "gray.50", color = "gray.800", columns, ...props }) {
	let { data, isLoading } = props;
	const memorizedData = React.useMemo(() => (data ? data : [{}]), [data]);

	const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow } = useTable({
		columns,
		data: memorizedData || [],
	});

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<Table key={rows.id} {...getTableProps()} size="sm" variant="simple">
					{rows.length > 0 ? (
						<>
							<Thead key={rows.id} zIndex="2" pos="sticky" top="0" bg={background}>
								{headerGroups.map((headerGroup) => (
									<Tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<Th fontWeight="bold" py="4" {...column.getHeaderProps()} color={color}>
												{column.render("Header")}
											</Th>
										))}
									</Tr>
								))}
							</Thead>
							<Tbody {...getTableBodyProps()}>
								{rows.map((row) => {
									prepareRow(row);
									return (
										<MotionRow
											initial={{ opacity: 0 }}
											animate={{ opacity: 1 }}
											transition={{ duration: 0.2 }}
											cursor="default"
											_hover={{ bg: "gray.50" }}
											{...row.getRowProps()}
										>
											{row.cells.map((cell) => (
												<Td key={row.id} {...cell.getCellProps()}>
													{cell.render("Cell")}
												</Td>
											))}
										</MotionRow>
									);
								})}
							</Tbody>
							<Tfoot>
								{rows.length > 0 && (
									<>
										{footerGroups.map((group) => (
											<Tr {...group.getFooterGroupProps()}>
												{group.headers.map((column) => (
													<>
														<td  key={column.id} {...column.getFooterProps()}>
															{column.render("Footer")}
														</td>
													</>
												))}
											</Tr>
										))}
									</>
								)}
							</Tfoot>
						</>
					) : (
						<Center pos="absolute" top="50%" right="50%" flex="1" color="gray.400">
							<BiServer size="1.1rem" /> <Text fontSize="md">&nbsp;No data.</Text>
						</Center>
					)}
				</Table>
			)}
		</>
	);
}
